import { isSuperAdminOrOwner } from '@jira-clone/shared-types';

interface MaybeUser {
  role?: string | null;
  department?: string | null;
}

/** An Admin in the HR department. Mirrors the server's rule for who may approve leave and edit HR settings. */
export function isHrDepartmentAdmin(user: MaybeUser | null | undefined): boolean {
  return String(user?.role ?? '').toLowerCase() === 'admin' && String(user?.department ?? '').toLowerCase() === 'hr';
}

/** Who sees Settings > HR: owners and super admins, and Admins of the HR department. */
export function canManageHrSettings(user: MaybeUser | null | undefined): boolean {
  return isSuperAdminOrOwner(user?.role) || isHrDepartmentAdmin(user);
}
